// extracted by mini-css-extract-plugin
export var content = "_nw-1";
export var noScroll = "_nw-3";
export var paper = "_nw-0";
export var scrollable = "_nw-2";